import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchChildCategories } from '../../api/childCategoryApi';

export const getChildCategories = createAsyncThunk('childCategory/getChildCategories', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchChildCategories(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const childCategorySlice = createSlice({
  name: 'childCategory',
  initialState: {
    childCategories: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChildCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getChildCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.childCategories = action.payload;
      })
      .addCase(getChildCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default childCategorySlice.reducer;
